import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Style from '../assets/css/blog.module.css';
import { database, storage } from '../../firebase';
import { ref, set, onValue } from 'firebase/database';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

const Blog = ({ user }) => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');
    const [sortOrder, setSortOrder] = useState('desc');
    const [newPost, setNewPost] = useState({ title: '', content: '', images: '' });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [articles, setArticles] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [imageCaptions, setImageCaptions] = useState([]);
    const [visibleArticles, setVisibleArticles] = useState(0);
    const modules = {
        toolbar: [
            [{ 'header': '1'}, { 'header': '2'}, { 'font': [] }],
            [{ 'size': ['small', 'normal', 'large', 'huge'] }],
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
        ],
    };

    useEffect(() => {
        const articlesRef = ref(database, 'posts/');
        onValue(articlesRef, (snapshot) => {
            const data = snapshot.val();
            const articlesList = [];
            for (let id in data) {
                articlesList.push({ id, ...data[id] });
            }
            setArticles(articlesList);
        });
    }, []);

    useEffect(() => {
        if (articles.length > 0) {
            const interval = setInterval(() => {
                setVisibleArticles((prevVisible) => {
                    if (prevVisible < articles.length) {
                        return prevVisible + 1;
                    } else {
                        clearInterval(interval);
                        return prevVisible;
                    }
                });
            }, 300);
        }
    }, [articles]);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => {
        setSelectedFiles([]);
        setImageCaptions([]);
        setNewPost({ title: '', content: '', images: '' });
        setIsModalOpen(false);
    };

    const handleInputChange = (field, value) => {
        setNewPost((prev) => ({ ...prev, [field]: value }));
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFiles(files);
        setImageCaptions(Array(files.length).fill(''));
    };

    const handleCaptionChange = (index, value) => {
        const updatedCaptions = [...imageCaptions];
        updatedCaptions[index] = value;
        setImageCaptions(updatedCaptions);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const storage = getStorage();
        const imageUrls = [];

        for (let i = 0; i < selectedFiles.length; i++) {
            const file = selectedFiles[i];
            const storageReference = storageRef(storage, `posts_images/${new Date().getTime()}_${file.name}`);

            await uploadBytes(storageReference, file);
            const url = await getDownloadURL(storageReference);
            imageUrls.push(url);
        }

        const newPostRef = ref(database, 'posts/' + new Date().getTime());

        await set(newPostRef, {
            title: newPost.title,
            content: newPost.content,
            images: imageUrls,
            captions: imageCaptions,
            date: new Date().toISOString(),
            author: user.displayName || user.email
        });
        Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
        });
        closeModal();
    };

    const allowedUsers = [
        'zevach98zen@gmail.com',
        'thomync9876@gmail.com',
        'michellesuhey.palacios@gmail.com',
        'e9512351958@gmail.com',
        'xemaiagl@gmail.com',
        'alebarraber@gmail.com',
        'mixtecnautas@gmail.com'
    ];

    const filteredArticles = articles
        .filter(article => article.title.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
        });

    const handleArticleClick = (id) => {
        navigate(`/article/${id}`);
    };

    return (
        <>
            <div className={Style.blogContainer}>
                <h1 className={Style.blogTitle}>{t('blog')}</h1>
                {user && allowedUsers.includes(user.email) && (
                    <button className={Style.writePostButton} onClick={openModal}>
                        Escribir un post
                    </button>
                )}
                <div className={Style.filterContainer}>
                    <input
                        type="text"
                        placeholder={t('blogInput')}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={Style.searchInput}
                    />
                    <select
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        className={Style.sortSelect}
                    >
                        <option value="desc">{t('blogRecent')}</option>
                        <option value="asc">{t('blogOlder')}</option>
                    </select>
                </div>
                <div className={Style.articles}>
                    {filteredArticles.map((article, index) => (
                        <div
                            key={article.id}
                            className={`${Style.article} ${index < visibleArticles ? Style.visible : ''}`}
                            onClick={() => handleArticleClick(article.id)}
                        >
                            {article.images && article.images.length > 0 ? (
                                <img
                                    src={article.images[0]}
                                    alt={`Imagen del artículo ${article.title}`}
                                    className={Style.articleImage}
                                />
                            ) : (
                                <img
                                    src='https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg'
                                    alt='No image'
                                    className={Style.articleImage}
                                />
                            )}
                            <h2 className={Style.articleTitle}>{article.title}</h2>
                            <div className={Style.description}>
                                <p className={Style.articleAuthor}>Escrito por: {article.author}</p>
                                <p className={Style.articleDate}>{new Date(article.date).toLocaleDateString()}</p>
                            </div>
                        </div>
                    ))}
                </div>
                {isModalOpen && (
                    <div className={Style.modalOverlay}>
                        <div className={Style.modalContent}>
                            <h2>Crear un nuevo post</h2>
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <label>Título:</label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={newPost.title}
                                        onChange={(e) => handleInputChange('title', e.target.value)}
                                        required
                                    />
                                </div>
                                <div>
                                    <label>Contenido:</label>
                                    <div className={Style.editorWrapper}>
                                        <ReactQuill
                                            theme="snow"
                                            value={newPost.content}
                                            onChange={(value) => handleInputChange('content', value)}
                                            modules={modules}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>Subir imágenes:</label>
                                    <input
                                        type="file"
                                        name="images"
                                        multiple
                                        onChange={(e) => handleFileChange(e)}
                                    />
                                    <div className={Style.imagePreview}>
                                        {selectedFiles.length > 0 && (
                                            <div>
                                                {Array.from(selectedFiles).map((file, index) => (
                                                    <div key={index} className={Style.imageContainer}>
                                                        <img
                                                            src={URL.createObjectURL(file)}
                                                            alt={`Previsualización ${index + 1}`}
                                                            className={Style.previewImage}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="Pie de imagen (opcional)"
                                                            value={imageCaptions[index]}
                                                            onChange={(e) => handleCaptionChange(index, e.target.value)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className={Style.buttonsBlog}>
                                    <button type="button" onClick={closeModal}>Cancelar</button>
                                    <button type="submit">Guardar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Blog;
